export default function RiskManagement() {
  const risks = [
    {
      risk: 'ضعف الإقبال',
      solution: 'شراكات جامعية',
      icon: 'ri-user-add-line',
      description: 'بناء شراكات استراتيجية مع الجامعات لضمان تدفق مستمر من الطلاب'
    },
    {
      risk: 'ارتفاع التكاليف',
      solution: 'رعايات متعددة',
      icon: 'ri-money-dollar-circle-line',
      description: 'تنويع مصادر التمويل من خلال شراكات متعددة مع شركات مختلفة'
    },
    {
      risk: 'الاستدامة',
      solution: 'تنويع الدخل',
      icon: 'ri-line-chart-line',
      description: 'إنشاء مصادر دخل متنوعة لضمان الاستدامة المالية طويلة المدى'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white relative overflow-hidden">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>
      
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            المخاطر وإدارتها
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            تحديد المخاطر المحتملة والحلول الاستباقية
          </p>
        </div>

        {/* Table Format */}
        <div className="max-w-5xl mx-auto mb-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl border border-white/20 overflow-hidden">
            <div className="grid grid-cols-2 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53]">
              <div className="p-6 text-center font-bold text-xl border-l border-white/20">
                الخطر
              </div>
              <div className="p-6 text-center font-bold text-xl">
                الحل
              </div>
            </div>
            {risks.map((item, index) => (
              <div
                key={index}
                className={`grid grid-cols-2 ${index !== risks.length - 1 ? 'border-b border-white/20' : ''}`}
              >
                <div className="p-6 text-center font-semibold text-lg border-l border-white/20">
                  {item.risk}
                </div>
                <div className="p-6 text-center font-semibold text-lg text-[#FF8E53]">
                  {item.solution}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Detailed Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {risks.map((item, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 hover:bg-white/20 transition-all duration-300"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center mb-6">
                <i className={`${item.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="font-bold text-xl mb-2 text-[#FF8E53]">
                {item.risk}
              </h3>
              <h4 className="font-semibold text-lg mb-4">
                الحل: {item.solution}
              </h4>
              <p className="text-gray-300 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
